import * as Actions from '../../actions/integration/type';

const initialState = {
  setUpLoading: false,
  setUpAccountData: {},
  setUpErr: '',
  accountsLoading: false,
  partsTechAccounts: null,
  accountsErr: '',
  updateAccountUpLoading: false,
  updatedAccount: {},
  updateAccErr: '',
};

export const partTechReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SETUP_PART_TECH_CREDS_REQUEST:
      return {
        ...state,
        setUpLoading: true,
      };
    case Actions.SETUP_PART_TECH_CREDS_SUCCESS:
      return {
        ...state,
        setUpLoading: false,
        // setUpAccountData: action?.payload || '',
        setUpAccountData: { ...action?.payload?.partsTechCredentials } || '',
        // partsTechAccounts: [
        //   ...state?.partsTechAccounts,
        //   action?.payload?.partsTechCredentials,
        // ],
        partsTechAccounts: action?.payload?.partsTechCredentials,
      };
    case Actions.SETUP_PART_TECH_CREDS_FAIL:
      return {
        ...state,
        setUpLoading: false,
        setUpErr: action?.payload?.message || '',
      };
    // PartsTech accounts
    case Actions.GET_PART_TECH_ACCOUNTS_REQUEST:
      return {
        ...state,
        accountsLoading: true,
      };
    case Actions.GET_PART_TECH_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accountsLoading: false,
        partsTechAccounts: action?.payload?.partsTechCredentials || '',
      };
    case Actions.GET_PART_TECH_ACCOUNTS_FAIL:
      return {
        ...state,
        accountsLoading: false,
        accountsErr: '',
      };
    // update  PartsTech account
    case Actions.UPDATE_PART_TECH_ACCOUNT_REQUEST:
      return {
        ...state,
        updateAccountUpLoading: true,
      };
    case Actions.UPDATE_PART_TECH_ACCOUNT_SUCCESS:
      // const accountsData = state?.partsTechAccounts || [];
      // const updatedData = action?.payload?.data || {};
      // const accToUpdateindex = accountsData?.findIndex(
      //   (acc) => acc?.id === updatedData?.id,
      // );
      // if (accToUpdateindex > -1) {
      //   accountsData[accToUpdateindex] = updatedData;
      // }

      return {
        ...state,
        updateAccountUpLoading: false,
        // updatedAccount: action?.payload?.data || '',
        partsTechAccounts: action?.payload?.data,
      };
    case Actions.UPDATE_PART_TECH_ACCOUNT_FAIL:
      return {
        ...state,
        updateAccountUpLoading: false,
        updateAccErr: action?.payload?.message || '',
      };
    case Actions.CLEAR_PART_TECH_STATE:
      return {
        ...state,
        setUpLoading: false,
        setUpAccountData: {},
        setUpErr: '',
        accountsLoading: false,
        // partsTechAccounts: [],
        accountsErr: '',
        updateAccountUpLoading: false,
        updatedAccount: {},
        updateAccErr: '',
      };
    default:
      return state;
  }
};
